import { Window } from '@imus/services-ui';
import { WindowContent } from 'imdui';
import { useTranslation } from 'react-i18next';
import { ShareWindowContent } from './ShareWindowContent';

export const ShareWindow = ({
  isOpen,
  close,
  url,
}: {
  isOpen: boolean;
  close: () => void;
  url?: string;
}) => {
  const { t } = useTranslation();

  return (
    <Window hideClose isOpen={isOpen} close={close}>
      <WindowContent
        style={{ maxWidth: '480px' }}
        onRequestClose={close}
        title={t('share')}
      >
        <ShareWindowContent url={url} />
      </WindowContent>
    </Window>
  );
};

export { ShareWindowContent } from './ShareWindowContent';
